export const setIds = (defaultIds = [], item) => {
  item.ids = [].concat(defaultIds)
  item.ids.push(item.categoryId)
  if (item.children) {
    item.children.forEach((item2) => {
      setIds(item.ids, item2)
    })
  }
}

export const findIds = () => {

}
